var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 37,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#00C5D7",
    cx: 19.086,
    cy: 18.34,
    r: 15.434
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07 12.905c0-2.864.781-5.547 2.141-7.847-4.547 2.688-7.598 7.64-7.598 13.305 0 8.529 6.914 15.443 15.444 15.443 5.665 0 10.616-3.05 13.304-7.597a15.376 15.376 0 0 1-7.847 2.14c-8.53.001-15.444-6.913-15.444-15.444z",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.438 28.699V18.621H46.412v10.078h-1.45V7.693h1.45v9.609h12.026V7.693h1.436v21.006h-1.436zM74.874 28.699v-2.725h-.059c-1.045 2.061-2.656 3.091-4.834 3.091-3.545 0-5.317-2.231-5.317-6.694v-8.672h1.362v8.335c0 2.031.334 3.506 1.004 4.424.668.918 1.721 1.377 3.156 1.377 1.396 0 2.527-.513 3.391-1.538.865-1.025 1.297-2.393 1.297-4.102v-8.496h1.348v15h-1.348zM82.433 26.033h-.059v2.666h-1.348V6.492h1.348V16.79h.059c.537-1.104 1.306-1.956 2.307-2.556s2.103-.901 3.304-.901c1.904 0 3.392.657 4.46 1.97 1.07 1.313 1.604 3.098 1.604 5.354 0 2.51-.62 4.539-1.86 6.087-1.24 1.548-2.852 2.321-4.834 2.321-2.247 0-3.907-1.01-4.981-3.032zm-.059-5.581v1.89c0 1.504.474 2.795 1.421 3.875.947 1.079 2.192 1.618 3.735 1.618 1.533 0 2.778-.656 3.735-1.97.957-1.313 1.436-3.04 1.436-5.178 0-1.875-.439-3.364-1.318-4.468s-2.051-1.655-3.516-1.655c-1.748 0-3.101.586-4.058 1.758s-1.435 2.548-1.435 4.13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.98b3534dee9dbd0871c204229828074d.svg";
export { ForwardRef as ReactComponent };